
import React from 'react';
import { TableHeader, TableRow, TableHead } from '@/components/ui/table';
import SortableTableHeader from './SortableTableHeader';
import { SortField, SortDirection } from './SortableTableHeader';
import { useIsMobile } from '@/hooks/use-mobile';

interface AttendeeTableHeaderProps {
  sortField: SortField;
  sortDirection: SortDirection;
  onSort: (field: SortField) => void;
  showContribution: boolean;
}

const AttendeeTableHeader: React.FC<AttendeeTableHeaderProps> = ({ 
  sortField, 
  sortDirection, 
  onSort,
  showContribution
}) => {
  const isMobile = useIsMobile();
  
  return (
    <TableHeader>
      <TableRow className="hover:bg-transparent">
        <SortableTableHeader 
          field="name" 
          label="Họ tên"
          currentSort={sortField} 
          direction={sortDirection}
          onSort={onSort}
          className={isMobile ? 'max-w-[100px]' : ''}
        />
        <TableHead className={`text-muted-foreground ${isMobile ? 'pl-2 pr-1 py-2 text-xs' : ''}`}>
          Mã
        </TableHead>
        <TableHead className={`text-muted-foreground ${isMobile ? 'pl-2 pr-1 py-2 text-xs' : ''}`}>
          Lớp
        </TableHead>
        <SortableTableHeader 
          field="t_shirt_size" 
          label="Size áo"
          currentSort={sortField} 
          direction={sortDirection}
          onSort={onSort}
          className={isMobile ? 'pl-2 pr-1 py-2 text-xs' : ''}
        />
        <SortableTableHeader 
          field="registeredAt" 
          label="Đăng ký" 
          currentSort={sortField}
          direction={sortDirection} 
          onSort={onSort}
          className={isMobile ? 'pl-2 pr-1 py-2' : ''}
        />
        <TableHead className={`text-muted-foreground ${isMobile ? 'pl-2 pr-1 py-2 sticky right-[64px] bg-white/95 dark:bg-gray-900/95 z-10 text-xs' : ''}`}>
          Đã TT
        </TableHead>
        <TableHead className={`text-muted-foreground ${isMobile ? 'pl-2 pr-1 py-2 sticky right-0 bg-white/95 dark:bg-gray-900/95 z-10 text-xs' : ''} ${!isMobile ? 'text-right' : ''}`}>
          Tham dự
        </TableHead>
        {!isMobile && (
          <TableHead className="text-muted-foreground text-center">
            Check-in
          </TableHead>
        )}
        {showContribution && (
          <SortableTableHeader 
            field="contribution" 
            label="Đóng góp"
            currentSort={sortField} 
            direction={sortDirection}
            onSort={onSort}
            className={isMobile ? 'pl-2 pr-1 py-2 whitespace-nowrap' : ''}
          />
        )}
      </TableRow>
    </TableHeader>
  );
};

export default AttendeeTableHeader;
